import { Container } from "../styles";
import { useState, useEffect, useRef } from "react";
import api from "../../../../../../../../services/api";
import { comum } from "../../../../../../../../styles/Themes/light";
import { IconUser } from "../../../../../../../icons";
import OfficeSelector from "../../../../../../../OfficeSelector";
import Skeleton from "react-loading-skeleton";
import ModalContato from "../../../../../../Common/ModalContato";
import { Mail, MoreVertical, Eye } from "lucide-react";
import { useAuth } from "../../../../../../../../contexts/UserContext";
import { usuarioEhCorrespondente, usuarioEhSolicitante, usuarioNaoPodeVerContato, podeEditarDemanda } from "../../../../../../../../helpers/permissoesUsuario";
import { MenuContainer, MenuButton, MenuDropdown, MenuItem } from "../CardParteProfissional/styles";

export default function CardParteSolicitante({demanda}: {demanda: any}) {
    const { user } = useAuth();
    const [escritorioSolicitante, setEscritorioSolicitante] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [modalContato, setModalContato] = useState(false);
    const [menuAberto, setMenuAberto] = useState(false);
    const [menuPosition, setMenuPosition] = useState<{ top: number; right: number } | null>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const menuButtonRef = useRef<HTMLButtonElement>(null);


    async function carregaSolicitante(id_escritorio_solicitante?: number) {
        if(!id_escritorio_solicitante) return;

        setLoading(true);
        const responseSolicitante = await api.get('escritorio/' + id_escritorio_solicitante);
        setLoading(false);

        if (responseSolicitante.data.status !== 'success') {
            throw new Error("Erro ao carregar escritório solicitante");
        }

        setEscritorioSolicitante(responseSolicitante.data.result);
    }

    useEffect(() => {
        if (!demanda?.id_escritorio_solicitante) return;

        if (demanda.nome_escritorio) {
            setEscritorioSolicitante({
                id_escritorio_solicitante: demanda.id_escritorio_solicitante,
                nome: demanda.nome_escritorio,
                email: demanda.email_escritorio
            });
        } else {
            carregaSolicitante(demanda.id_escritorio_solicitante);
        }
    }, [demanda.id_escritorio_solicitante]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setMenuAberto(false);
                setMenuPosition(null);
            }
        };

        const handleScroll = () => {
            if (menuAberto && menuButtonRef.current) {
                const rect = menuButtonRef.current.getBoundingClientRect();
                setMenuPosition({
                    top: rect.bottom + 8,
                    right: window.innerWidth - rect.right
                });
            }
        };

        if (menuAberto) {
            document.addEventListener('mousedown', handleClickOutside);
            window.addEventListener('scroll', handleScroll, true);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [menuAberto]);

    const handleAbrirMenu = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (menuButtonRef.current) {
            const rect = menuButtonRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + 8,
                right: window.innerWidth - rect.right
            });
        }
        setMenuAberto(!menuAberto);
    };

    const handleVisualizar = () => {
        setMenuAberto(false);
        setMenuPosition(null);
        setModalContato(true);
    };

    if ((usuarioEhCorrespondente(user) || usuarioEhSolicitante(user)) && !escritorioSolicitante && !loading) {
        return null;
    }

    return (
        <Container>
            {loading && (
                <div className="parte-select">
                    <Skeleton height={40} width="100%" />
                </div>
            )}

            {!loading && (
            <>
            <span className="label">Escritório Solicitante</span>
            {escritorioSolicitante && (
                <>
        	<div className="parte">
                <div className="iconc">
                <IconUser color={comum.colors.primaryRed400}/>
                </div>
                <div className="info">
                    <span className="nome">{escritorioSolicitante.nome.split(' ')[0]}</span>
                    <span className="codigo">ES{escritorioSolicitante.id_escritorio_solicitante}</span>
                </div>
                {!usuarioNaoPodeVerContato(user) && (
                    <MenuContainer ref={menuRef}>
                        <MenuButton
                            ref={menuButtonRef}
                            onClick={handleAbrirMenu}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleAbrirMenu(e as any);
                                }
                            }}
                            aria-label="Menu de ações"
                        >
                            <MoreVertical size={18} />
                        </MenuButton>
                        {menuAberto && menuPosition && (
                            <MenuDropdown style={{ top: `${menuPosition.top}px`, right: `${menuPosition.right}px` }}>
                                <MenuItem
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleVisualizar();
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleVisualizar();
                                        }
                                    }}
                                >
                                    <Eye size={16} />
                                    Visualizar
                                </MenuItem>
                            </MenuDropdown>
                        )}
                    </MenuContainer>
                )}
            </div>
            {!usuarioNaoPodeVerContato(user) && (
                <ModalContato  modalAtivo={modalContato} setModalAtivo={setModalContato} >
                    <div className="contact-item">
                        <Mail />
                        {escritorioSolicitante.email}
                    </div>
                </ModalContato>
            )}
            </>
            )}

            {!escritorioSolicitante && podeEditarDemanda(user) && (
                <div className="parte-select">
                    <OfficeSelector
                        id_proposta={demanda?.id_proposta}
                        selectedOffice={escritorioSolicitante}
                        onSelectOffice={carregaSolicitante}
                    />
                </div>
            )}

            {!escritorioSolicitante && !podeEditarDemanda(user) && (
                <div className="parte-vazio">
                    Nenhum solicitante atribuído
                </div>
            )}
            </>
            )}
        </Container>
    )
}